<template>
  <div>

    <form id="formSiteSetupGeneral" @change="clearErrors()" class="d-flex flex-column" v-on:submit.prevent="updateGeneralSiteSettings">
      <div class="d-flex flex-column tab-card-form">
        <div class="element-info">
          <div class="row align-items-center">
            <div v-if="this.mobile" class="col-sm-8">
              <div class="element-info-with-icon justify-content-center">
                <div class="element-info-text text-center">
                  <h5 class="element-inner-header text-center">General Settings</h5>
                  <div class="element-inner-desc">Here you can change the general settings of the site.</div>
                </div>
              </div>
            </div>
            <div v-else class="col-sm-8">
              <div class="element-info-with-icon">
                <div class="element-info-icon">
                  <fontAwesomeIcon :icon="['fas', 'cogs']" size="2x" />
                </div>
                <div class="element-info-text ml-5">
                  <h5 class="element-inner-header">General Settings</h5>
                  <div class="element-inner-desc">Here you can change the general settings of the site.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-box d-flex flex-column">
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">Name</span></b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field">{{ allTemplateDetails.name }}</span>
              </b-input-group>
            </b-form-group>
            <b-form-group v-if="this.mobile" class="mt-3 col-lg-6 col-sm-12" >
              <div slot="description">
                <p>This address will receive a copy of the Proof/Progress/Final Reports if none is specified for the batch's type</p>
              </div>
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">Admin email</span></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="setupGeneral.admin_email" required></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group v-else class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">Admin email</span></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="admin_email" v-model="setupGeneral.admin_email" required></b-form-input>
                <b-popover target="admin_email" triggers="focus" title="Tip">
                  <div class="text-size-small">
                    <p>This address will receive a copy of the Proof/Progress/Final Reports if none is specified for the batch's type</p>
                  </div>
                </b-popover>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group v-if="this.mobile" class="mt-3 col-lg-6 col-sm-12">
              <div slot="description">
                <p>This address will appear in the "From:" field of emails sent to customers</p>
              </div>
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">Reply email</span></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="setupGeneral.reply_email" required></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group v-else class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">Reply email</span></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="reply_email" v-model="setupGeneral.reply_email" required></b-form-input>
                <b-popover target="reply_email" triggers="focus" title="Tip">
                  <div class="text-size-small">
                    <p>This address will appear in the "From:" field of emails sent to customers</p>
                  </div>
                </b-popover>
              </b-input-group>
            </b-form-group>
            <b-form-group v-if="this.mobile" class="mt-3 col-lg-6 col-sm-12">
              <div slot="description">
                <p>This address will receive queries raised via the online statements (unless a specific address is specified for the corresponding principal). <span class="text-info d-block">Separate multiple email addresses with a comma.</span></p>
              </div>
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">Query email</span></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="setupGeneral.query_email"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group v-else class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">Query email</span></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="query_email" v-model="setupGeneral.query_email"></b-form-input>
                <b-popover target="query_email" triggers="focus" title="Tip">
                  <div class="text-size-small">
                    <p>This address will receive queries raised via the online statements (unless a specific address is specified for the corresponding principal). <span class="text-info d-block">Separate multiple email addresses with a comma.</span></p>
                  </div>
                </b-popover>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group v-if="this.mobile" class="mt-3 col-lg-6 col-sm-12" >
              <div slot="description">
                <p>This address will receive remittance notifications raised via the online statements. <span class="text-info d-block">Separate multiple email addresses with a comma or semicolon.</span></p>
              </div>
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">Remittance email</span></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="setupGeneral.remittance_email"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group  v-else class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">Remittance email</span></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="remittance_email" v-model="setupGeneral.remittance_email"></b-form-input>
                <b-popover target="remittance_email" triggers="focus" title="Tip">
                  <div class="text-size-small">
                    <p>This address will receive remittance notifications raised via the online statements. <span class="text-info d-block">Separate multiple email addresses with a comma or semicolon.</span></p>
                  </div>
                </b-popover>
              </b-input-group>
            </b-form-group>
            <b-form-group v-if="(getUserDetails.level == 3) && this.mobile" class="mt-3 col-lg-6 col-sm-12">
              <div slot="description">
                <p>This address will always receive a copy of the Proof/Progress/Final Reports. <span class="text-info d-block">Separate multiple email addresses with a comma or semicolon.</span></p>
              </div>
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">Report email</span></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="setupGeneral.report_email" required></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group v-if="(getUserDetails.level == 3) && !this.mobile" class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">Report email</span></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="report_email" v-model="setupGeneral.report_email" required></b-form-input>
                <b-popover target="report_email" triggers="focus" title="Tip">
                  <div class="text-size-small">
                    <p>This address will always receive a copy of the Proof/Progress/Final Reports. <span class="text-info d-block">Separate multiple email addresses with a comma.</span></p>
                  </div>
                </b-popover>
              </b-input-group>
            </b-form-group>
          </div>
          <b-form-group class="mt-3 align-self-start">
            <b-input-group>
              <b-form-checkbox
                v-model="setupGeneral.show_newsnet"
                name="show_newsnet"
                :value="1"
                :unchecked-value="0">
                Show Newsnet logo
              </b-form-checkbox>
            </b-input-group>
          </b-form-group>
          <b-form-group class="mt-3 align-self-start">
            <b-input-group>
              <b-form-checkbox
                v-model="setupGeneral.reverse_coversheet"
                name="reverse_coversheet"
                :value="1"
                :unchecked-value="0">
                Put post coversheet on the front
              </b-form-checkbox>
            </b-input-group>
          </b-form-group>
          <transition name="fade">
            <ValidationErrors v-if="getValidationErrors.validationName == 'siteSetupGeneral'" class="mt-3"/>
          </transition>
          <transition name="fade">
            <ResponseInfo v-if="getResponseInfo.name == 'siteSetupGeneral'" class="mt-3"/>
          </transition>
          <button v-if="!this.mobile" class="btn btn-primary mt-3 align-self-end" type="submit" value="submit">Update</button>
          <button v-else class="btn btn-secondary mt-3 align-self-end" type="submit" value="submit">Update</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'

export default{
  name: 'SiteSetupGeneralSettings',
  components:{
    ResponseInfo,
    ValidationErrors
  },
  data() {
    return {
      setupGeneral: {},
      mobile: window.innerWidth <= 700
    }
  },
  computed:{
      ...mapGetters(['allTemplateDetails', 'getUserDetails', 'getIsNewsnet', 'getGeneralSiteSettings', 'getResponseInfo', 'getValidationErrors']),
      generalSiteSettings: {
          get() {
              return this.$store.getters.getGeneralSiteSettings
          }
      }
  },
  created() {
      generalSiteSettings:{
          this.$store.dispatch('getGeneralSiteSettings')
          .then(() => {
              if(Object.keys(this.generalSiteSettings).length){
                  this.setupGeneral = Object.assign({}, this.generalSiteSettings)
              }
          })
      }
      window.addEventListener('resize', () => {
            this.mobile = window.innerWidth <= 700
      })
  },
  methods: {
      clearErrors() {
        //clearing the error message when we change the input
        this.$store.commit('setValidationErrors', [])
      },
      updateGeneralSiteSettings(){
        this.$store.dispatch('setGeneralSiteSettings',{
            data: this.setupGeneral
        })
      }
  }
}
</script>

<style lang="css" scoped>
  .tab-card-form{
    min-width: 70%;
  }
  .pretext{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pretext-span{
    width: 100%;
    white-space: normal;
  }
  .text-size-small{
    font-size: 0.8rem;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .disabled-field {
    background-color: rgb(233, 236, 239);
  }
</style>
